import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Navigation } from './Navigation';

interface FullPageSpinnerProps {
    message: string;
}

export const FullPageSpinner: React.FC<FullPageSpinnerProps> = ({ message }) => {
    const theme = useTheme();

    const styles = {
        container: {
            minHeight: '100vh',
            backgroundColor: theme.colors.background,
        },
        content: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 'calc(100vh - 80px)', // Subtract navbar height
            flexDirection: 'column' as const,
            gap: theme.spacing.lg,
        },
        spinner: {
            width: '120px',
            height: '120px',
        },
        message: {
            fontSize: theme.typography.fontSize.lg,
            color: theme.colors.text.secondary,
        }
    };

    return (
        <div style={styles.container}>
            <Navigation />
            <div style={styles.content}>
                <img
                    src="/logo-spinner.gif"
                    alt="Loading..."
                    style={styles.spinner}
                />
                <div style={styles.message}>
                    {message}
                </div>
            </div>
        </div>
    );
};
